import React from 'react';
import {injectStripe} from 'react-stripe-elements';
import './style.css';
import {Elements, StripeProvider} from 'react-stripe-elements';
import {CardNumberElement, CardExpiryElement, CardCVCElement} from 'react-stripe-elements';
import Button from 'components/shared/button';
import CouponElement from './coupon_element'
import css from './style.scss'
import cn from 'classnames'
class _Form extends React.Component{
  constructor(props){
    super(props)
    this.state={
      coupon:undefined
    }
  }
  handleSubmit = (ev) => {
    this.props.onSubmit()
    // We don't want to let default form submission happen here, which would refresh the page.
    ev.preventDefault();

    this.props.stripe.createToken({name: this.props.user_name}).then(({token}) => {
      if(token){
        this.props.onSuccessTokenCreation({stripeObject:token, coupon:this.state.coupon});
      }else{
        this.props.onError()
      }
    });
  }
  addCoupon=(coupon)=>{
    this.setState({coupon})
  }
  render() {
    let button=this.props.isChangingCard ? "Update card details" : "Go Premium"
    return (
      <form id="premiumForm" onSubmit={this.handleSubmit}>
        <label>Card Number</label>
        <CardNumberElement style={{base: {fontSize: '18px'}}} />
        <div className={css.cardRow}>
        <div className={cn(css.cardEl, css.first)}>
        <label>Expiration</label>
        <CardExpiryElement style={{base: {fontSize: '18px'}}} />
        </div>
        <div className={cn(css.cardEl, css.second)}>
        <label>CVC</label>
        <CardCVCElement style={{base: {fontSize: '18px'}}} />
        </div>
        </div>
        {!this.props.isChangingCard &&
          <CouponElement onCoupon={this.addCoupon}/>

        }
        <div className="buttons">
          <Button primary className="checkoutFormSubmit" type="submit">{button}</Button>
        </div>
      </form>
    );
  }
}

const Form = injectStripe(_Form);

const CheckoutForm=(props)=>{
  return (
    <StripeProvider apiKey={process.env.REACT_APP_STRIPE_KEY}>
      <Elements>
        <Form name={props.user_name} onError={props.onError} isChangingCard={props.isChangingCard || false} onSubmit={props.onSubmit} onSuccessTokenCreation={props.onSuccessTokenCreation}/>
      </Elements>
    </StripeProvider>
  );
}


export default CheckoutForm



// WEBPACK FOOTER //
// ./src/components/subscriptions/modal/checkout_form/form.js